import { ItemList } from '../orm'

class YocoTrolley extends ItemList {
    getEntityKey() {
        return "customer/purchased_trolley/prepare_yoco_payment"
    }

    prepareOrder({ trolley_id, total_price }) {
        return this.saveNewObject({
            trolley: trolley_id,
            total_price_in_cents: total_price,
        })
    }

}

export const yocoTrolley = new YocoTrolley("yoco_trolley_default")
